<template>
  <section id="price" class="bg-primary">
    <div class="md:container px-4 pt-16 lg:pb-0 pb-62">
      <div class="text-center md:mb-14 mb-6">
        <div class="inline-block rounded-full xs:px-20 px-12 py-3 text-xl md:text-2xl bg-opacity-10 bg-white text-white font-bree-serif">
          {{ $t('price.title') }}
        </div>
        <p class="md:text-xl text-lg text-white w-full lg:w-3/4 mx-auto mt-8">
          {{ $t('price.subtitle') }}
        </p>
      </div>
      <div class="flex flex-wrap lg:flex-nowrap">
        <div class="w-full lg:w-1/3 lg:mr-6 lg:mb-0 mb-6">
          <card-with-number rounded="12" min-height="500px" class="relative lg:min-h-full">
            <div class="p-4 lg:text-left text-center">
              <p class="font-bree-serif mb-4 text-3xl">
                {{ $t('doctor.title') }}
              </p>
              <p class="text-lg">
                {{ $t('priceDoctorDesc') }}
              </p>
              <p class="text-6xl font-rubik-medium lg:mt-20 mt-5 text-center">
                {{ $t('free') }}
              </p>
            </div>
            <div class="absolute bottom-4 left-0 w-full px-4">
              <button class="btn btn-success text-xl w-full uppercase" @click="$router.push(localeLocation({path: '/register/dokter'}))">
                {{ $t('signup') }}
              </button>
            </div>
          </card-with-number>
          <div class="bg-gold rounded-16 p-6 question-doctor text-white text-center lg:hidden">
            <img v-lazy-load data-src="@/assets/icon/icon-doctor-line.svg" alt="" class="mx-auto" width="50px" height="73px">
            <h2 class="my-6 font-bree-serif text-2xl">
              {{ $t('quest.questionDoctor') }}
            </h2>
            <p>{{ $t('quest.answerDoctor') }}</p>
          </div>
        </div>
        <div class="w-full lg:w-1/3 lg:mr-6 lg:mb-0 mb-6">
          <card-with-number rounded="12" class="relative">
            <div class="p-4 lg:text-left text-center mb-20">
              <p class="font-bree-serif mb-4 text-3xl">
                {{ $t('clinic') }}
              </p>
              <p class="text-lg">
                {{ $t('priceClinicDesc') }}
              </p>
              <div class="lg:mt-14 mt-5 text-center">
                <div class="flex flex-nowrap items-end justify-center">
                  <p class="text-2xl font-rubik-medium pb-3">
                    Rp
                  </p>
                  <p class="text-6xl font-rubik-medium">
                    16,667
                  </p>
                </div>
                <p class="xl:text-2xl text-xl mb-1">
                  /{{ $t('day') }}/{{ $t('doctor.title') }}
                </p>
                <p class="uppercase xl:text-2xl text-xl pb-6 border-b-2 border-black">
                  {{ $t('unlimitedConsultation') }}
                </p>
                <div class="text-primary mt-6 mb-10">
                  <p class="uppercase xl:text-2xl text-xl mb-4">
                    {{ $t('packageSelection') }}:
                  </p>
                  <template v-for="(sub, index) in subscriptionsClinic">
                    <card-with-number :key="index" rounded="12" bg-color="rgba(26,92,172, .1)" class="mb-4">
                      <div class="text-primary text-center">
                        <p class="text-lg">
                          {{ $t(validityPeriodInMonthsName(sub.ValidityPeriodInMonths)) }}
                        </p>
                        <h4 class="my-2">
                          Rp{{ sub.PackagePrice | formatMoney }}
                          <span>
                            /{{ $t(validityPeriodInMonthsUnitName(sub.ValidityPeriodInMonths)) }}
                          </span>
                        </h4>
                        <p class="text-lg">
                          {{ textForAccountDoctor($i18n.locale === 'en' ? 'EN' : 'ID', 'CLINIC') }}
                        </p>
                      </div>
                    </card-with-number>
                  </template>
                </div>
                <p class="text-2xl uppercase underline tracking-widest cursor-pointer font-rubik-medium text-success" @click="openModal('CLINIC')">
                  {{ $t('moreDetails') }}
                </p>
              </div>
            </div>
            <div class="absolute bottom-4 left-0 w-full px-4">
              <button class="btn btn-success text-xl w-full uppercase" @click="handleClickSignUp('CLINIC')">
                {{ $t('signup') }}
              </button>
            </div>
          </card-with-number>
        </div>
        <div class="w-full lg:w-1/3 lg:mb-0 mb-6">
          <card-with-number rounded="12" class="relative">
            <div class="p-4 lg:text-left text-center mb-20">
              <p class="font-bree-serif mb-4 text-3xl">
                {{ $t('hospital') }}
              </p>
              <p class="text-lg">
                {{ $t('priceHospitalDesc') }}
              </p>
              <div class="lg:mt-14 mt-5 text-center">
                <div class="flex flex-nowrap items-end justify-center">
                  <p class="text-2xl font-rubik-medium pb-3">
                    Rp
                  </p>
                  <p class="text-6xl font-rubik-medium">
                    16,667
                  </p>
                </div>
                <p class="xl:text-2xl text-xl mb-1">
                  /{{ $t('day') }}/{{ $t('doctor.title') }}
                </p>
                <p class="uppercase xl:text-2xl text-xl pb-6 border-b-2 border-black">
                  {{ $t('unlimitedConsultation') }}
                </p>
                <div class="text-primary mt-6 mb-10">
                  <p class="uppercase xl:text-2xl text-xl mb-4">
                    {{ $t('packageSelection') }}:
                  </p>
                  <template v-for="(sub, index) in subscriptionsHospital">
                    <card-with-number :key="index" rounded="12" bg-color="rgba(26,92,172, .1)" class="mb-4">
                      <div class="text-primary text-center">
                        <p class="text-lg">
                          {{ $t(validityPeriodInMonthsName(sub.ValidityPeriodInMonths)) }}
                        </p>
                        <h4 class="my-2">
                          Rp{{ sub.PackagePrice | formatMoney }}
                          <span>
                            /{{ $t(validityPeriodInMonthsUnitName(sub.ValidityPeriodInMonths)) }}
                          </span>
                        </h4>
                        <p class="text-lg">
                          {{ textForAccountDoctor($i18n.locale === 'en' ? 'EN' : 'ID', 'HOSPITAL') }}
                        </p>
                      </div>
                    </card-with-number>
                  </template>
                </div>
                <p class="text-2xl uppercase underline tracking-widest cursor-pointer font-rubik-medium text-success" @click="openModal('HOSPITAL')">
                  {{ $t('moreDetails') }}
                </p>
              </div>
            </div>
            <div class="absolute bottom-4 left-0 w-full px-4">
              <button class="btn btn-success text-xl w-full uppercase" @click="handleClickSignUp('HOSPITAL')">
                {{ $t('signup') }}
              </button>
            </div>
          </card-with-number>
          <div class="bg-gold rounded-16 p-6 question-hospital text-white text-center lg:hidden">
            <img v-lazy-load data-src="@/assets/icon/icon-hospital-line.svg" alt="" class="mx-auto" width="73px" height="73px">
            <h2 class="my-6 font-bree-serif text-2xl">
              {{ $t('quest.questionHospital') }}
            </h2>
            <p>{{ $t('quest.answerHospital') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--    yes-modal more plan-->
    <yes-modal
      v-if="modalMorePlan"
      :image-modal="false"
      text-center
      centered
      dialog-class="xl:w-4/5 md:w-11/12"
      bg-backdrop="bg-premier-blue"
      bg-opacity="bg-opacity-90"
      :show-close="true"
      @close="closeModal"
    >
      <div class="lg:px-10 px-4">
        <h3 class="font-bree-serif text-left mb-8">
          {{ type === 'CLINIC' ? $t('clinic') : $t('hospital') }}
        </h3>
        <div class="flex flex-wrap lg:flex-nowrap justify-center items-center text-left">
          <div
            v-for="(sub, i) in subscriptions"
            :key="i"
            class="w-full lg:w-1/3 lg:ml-5 lg:mr-5 mb-4"
          >
            <div class="card relative border-2 border-grey-light2">
              <h5 class="text-primary">
                {{ $t(validityPeriodInMonthsName(sub.ValidityPeriodInMonths)) }}
              </h5>
              <div v-if="$i18n.locale === 'en'" class="mt-6 mb-4">
                <p v-for="(list,index) in listsFullEnglish" :key="index" class="pb-2 flex flex-nowrap items-start">
                  <img v-lazy-load data-src="@/assets/icon/icon-check-circle-new.svg" alt="" class="mr-2">
                  <span>{{ list.name }}</span>
                </p>
              </div>
              <div v-else-if="$i18n.locale === 'id'" class="mt-6 mb-4">
                <p v-for="(list,index) in listsFullInd" :key="index" class="pb-2 flex flex-nowrap items-start">
                  <img v-lazy-load data-src="@/assets/icon/icon-check-circle-new.svg" alt="" class="mr-2">
                  <span>{{ list.name }}</span>
                </p>
              </div>
              <div>
                <div class="ribbon-1 absolute -left-4 mt-8 w-full">
                  <div class="bg-primary text-white rounded-r-6 rounded-bl-6 py-3 text-center">
                    <h3>Rp{{ packagePrice(sub.PackagePrice, sub.IncludeDoctorSlotQty, sub.ValidityPeriodInMonths) | formatMoney }} <span class="text-base font-rubik">/{{ $t('day') }}/{{ $t('doctor.title') }}</span></h3>
                    <h6 class="mt-1 uppercase">
                      {{ $t('unlimitedConsultation') }}
                    </h6>
                  </div>
                </div>
                <div v-if="sub.ValidityPeriodInMonths === 12 || sub.ValidityPeriodInMonths === 6" class="absolute right-8 font-rubik-medium text-white text-sm -mt-2 uppercase bg-danger rounded-t-14 px-4 py-3">
                  <span v-if="sub.ValidityPeriodInMonths === 12">{{ $t('badgePromo', {payMonth: '10', freeMonth: '2'}) }}</span>
                  <span v-else-if="sub.ValidityPeriodInMonths === 6">{{ $t('badgePromo', {payMonth: '5', freeMonth: '1'}) }}</span>
                </div>
              </div>
              <div class="mt-34 mb-4 text-center text-primary">
                <h4 class="mt-2">
                  Rp{{ sub.PackagePrice | formatMoney }}
                  <span class="font-rubik text-sm">
                    /{{ $t(validityPeriodInMonthsUnitName(sub.ValidityPeriodInMonths)) }}
                  </span>
                </h4>
                <p>{{ textForAccountDoctor($i18n.locale === 'en' ? 'EN' : 'ID', type) }}</p>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-success py-4 px-8 uppercase rounded-full my-6 font-rubik-medium" @click="handleClickSignUp(type)">
          {{ $t('signupNow') }}
        </button>
      </div>
    </yes-modal>
  </section>
</template>

<script>
import numeral from 'numeral'
export default {
  name: 'Price',
  filters: {
    formatMoney (value) {
      return numeral(value).format('0,0')
    }
  },
  data: () => ({
    modalMorePlan: false,
    subscriptions: [],
    subscriptionsClinic: [],
    subscriptionsHospital: [],
    subscription: null,
    type: ''
  }),
  computed: {
    listsFullEnglish () {
      return [
        {
          name: `${this.subscription.IncludeDoctorSlotQty} Doctor Accounts`
        },
        {
          name: `Free ${this.subscription.IncludeAdminSlotQty} Administrator Accounts`
        },
        {
          name: 'Flexible Doctor Accounts, Scheduling and Consultation Tariffs'
        },
        {
          name: 'Patient\'s Consultation History'
        },
        {
          name: 'Full Features'
        },
        {
          name: 'Daily Automatic Funds Withdrawal'
        },
        {
          name: 'Flexible Profit Sharing Setting'
        },
        {
          name: 'Comprehensive Reporting System'
        },
        {
          name: 'Open-connect to your Pharmacy'
        },
        {
          name: 'Available Electronic Medical Record'
        },
        {
          name: 'Complete Dashboard of 360° Performance'
        },
        {
          name: 'Online Consultation Training to Increase the Level of Success'
        }
      ]
    },
    listsFullInd () {
      return [
        {
          name: `Minimum ${this.subscription.IncludeDoctorSlotQty} Akun Dokter`
        },
        {
          name: `Gratis ${this.subscription.IncludeAdminSlotQty} Akun Admin`
        },
        {
          name: 'Bebas Undang Dokter'
        },
        {
          name: 'Bebas Tentukan Jadwal'
        },
        {
          name: 'Bebas Tentukan Tarif'
        },
        {
          name: 'Riwayat Konsultasi Pasien'
        },
        {
          name: 'Fasilitas Tanpa Batas'
        },
        {
          name: 'Akun Penarikan Dana Konsultasi Kapanpun'
        },
        {
          name: `Bebas Tentukan Bagi Hasil Dokter-${this.type === 'CLINIC' ? 'Klinik' : 'Rumah Sakit'}`
        },
        {
          name: 'Sistem Laporan Lengkap'
        },
        {
          name: 'Terkoneksi dengan Apotek Anda'
        },
        {
          name: 'Tersedia Elektronik Medical Record'
        },
        {
          name: 'Dashboard Lengkap Performa 360°'
        },
        {
          name: 'Pelatihan Konsultasi Online untuk Meningkatkan Tingkat Kesuksesan'
        }
      ]
    }
  },
  created () {
    this.fetchSubscriptionsWithType()
  },
  methods: {
    handleClickSignUp (type) {
      this.$store.commit('SET_REGISTER_TYPE', type)
      this.$router.push(this.localeLocation({ path: '/register' }))
    },
    closeModal () {
      this.modalMorePlan = false
      this.type = ''
    },
    openModal (type) {
      this.modalMorePlan = true
      this.subscriptions = this.fetchSubscriptions(type)
      this.type = type
      if (this.subscriptions.length > 0) {
        this.subscription = this.subscriptions[0]
      }
    },
    validityPeriodInMonthsUnitName (val) {
      if (val === 1) { return 'month' } else if (val === 6) { return 'sixMonth' } else if (val === 12) { return 'year' }
    },
    validityPeriodInMonthsName (val) {
      if (val === 1) { return 'monthly' } else if (val === 6) { return 'sixMonth' } else if (val === 12) { return 'yearly' }
    },
    fetchSubscriptions (type = '') {
      return [
        {
          ValidityPeriodInMonths: 1,
          IncludeDoctorSlotQty: type === 'CLINIC' ? 5 : 10,
          IncludeAdminSlotQty: type === 'CLINIC' ? 2 : 4,
          PackagePrice: type === 'CLINIC' ? 2500000 : 5000000
        },
        {
          ValidityPeriodInMonths: 6,
          IncludeDoctorSlotQty: type === 'CLINIC' ? 5 : 10,
          IncludeAdminSlotQty: type === 'CLINIC' ? 2 : 4,
          PackagePrice: type === 'CLINIC' ? 12500000 : 25000000
        },
        {
          ValidityPeriodInMonths: 12,
          IncludeDoctorSlotQty: type === 'CLINIC' ? 5 : 10,
          IncludeAdminSlotQty: type === 'CLINIC' ? 2 : 4,
          PackagePrice: type === 'CLINIC' ? 25000000 : 50000000
        }
      ]
    },
    fetchSubscriptionsWithType () {
      this.subscriptionsClinic = this.fetchSubscriptions('CLINIC')
      this.subscriptionsHospital = this.fetchSubscriptions('HOSPITAL')
    },
    packagePrice (PackagePrice, IncludeDoctorSlotQty, ValidityPeriodInMonths) {
      if (!PackagePrice || !IncludeDoctorSlotQty) { return '-' }
      return ((PackagePrice / (30 * ValidityPeriodInMonths)) / IncludeDoctorSlotQty).toFixed(2)
    },
    textForAccountDoctor (lang, type = '') {
      let text = ''
      if (lang === 'EN') {
        text = `For ${type === 'CLINIC' ? 5 : 10} Doctor Accounts`
      } else {
        text = `Untuk ${type === 'CLINIC' ? 5 : 10} Akun Dokter`
      }
      return text
    }
  }
}
</script>

<style scoped lang="scss">
.ribbon {
&::before {
   content: '';
   position: absolute;
   display: block;
   z-index: -1;
   border: 16px solid #144177;
   left: -31px;
   border-left-color: transparent;
   border-top-color: transparent;
 }
&::after {
   content: '';
   position: absolute;
   display: block;
   z-index: -1;
   border: 16px solid #144177;
   right: -31px;
   top: 0;
   border-right-color: transparent;
   border-top-color: transparent;
 }
}
.ribbon-1 {
  z-index: 1;
&::before {
   content: '';
   position: absolute;
   display: block;
   z-index: -1;
   border: 7px solid #144177;
   left: 0;
   top: -14px;
   border-left-color: transparent;
   border-top-color: transparent;
 }
}

.question-doctor {
  position: relative;
  margin-top: 3rem;
  &::before {
    content: '';
    position: absolute;
    top: -39px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 0;
    height: 0;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-bottom: 40px solid #E0AF06;
  }
}
.question-hospital {
  position: relative;
  margin-top: 3rem;
  &::before {
    content: '';
    position: absolute;
    top: -39px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 0;
    height: 0;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-bottom: 40px solid #E0AF06;
  }
}
</style>
